import React from "react";

import Navbar from "../Dashboard/Navbar";
import Sidebar from "../Dashboard/Sidebar";
import Footer from "../Footer";
import { Outlet } from "react-router-dom";
function Dashboard() {
  const SidebarList = [
    //dropdown list
    {
      category: "Dashboard",
      route: "",
    },
    {
      category: "New Registration",
      subcategory: [
        { name: "Approve", route: "new-reg/approve" },
        { name: "Add", route: "new-reg/add" },
      ],
    },
    {
      category: "View Publishers",
      subcategory: [
        { name: "Active", route: "publisher/active" },
        { name: "Inactive", route: "publisher/inactive" },
      ],
    },
    {
      category: "View Marketers",
      subcategory: [
        { name: "Active", route: "marketer/active" },
        { name: "Inactive", route: "marketer/inactive" },
      ],
    },
    {
      category: "View Revenue",
      route: "/admin/revenue",
    },
    // {
    //     category: "Modify Information",
    //     route: "/dashboard/admin/mod-info"
    // }
  ];
  const navMenu = [
    {
      link: "/",
      text: "Logout",
    },
  ];
  return (
    <>
      <Navbar navMenu={navMenu} />

      <div className="container-fluid" style={{minHeight:"110vh"}}>
        <div className="row h-90 ">
          <div className="col-2  shadow shadow-md">
            <Sidebar list={SidebarList} />
          </div>
          <div className="col-10">
            {" "}
            <Outlet />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Dashboard;
